// extracted by mini-css-extract-plugin
export default {"wrapper":"tablePagination_wrapper__Z4Try","disabled":"tablePagination_disabled__Mf7Nd","pageLink":"tablePagination_pageLink__Tg3uD","selected":"tablePagination_selected__Iyi+Y"};